export default {
  getFormDataError() {
    return Object.assign({}, {
      invoice_price: {
        required: false,
        pattern: false,
        maxOrMin: false,
      },
      mobile_phone: {
        required: false,
        pattern: false,
      },
      invoice_header: {
        required: false,
      },
      taxer_id_num: {
        required: false,
        pattern: false,
      },
      email: {
        pattern: false,
      },
      express: {
        addressee: {
          required: false,
        },
        mobile_phone: {
          pattern: false,
        },
        province_code: {
          required: false,
        },
        city_code: {
          required: false,
        },
        county_code: {
          required: false,
        },
        detail_address: {
          required: false,
        },
      },
    });
  },

  // 验证表单
  validateFormData(validatePrice, formData, totalOrderPrice, pcds) {
    let haveFieldError = false;
    const newFormDataError = this.getFormDataError();

    // 是否要验证金额
    if (validatePrice) {

      // 没输入开票金额
      if (!formData.invoice_price) {
        newFormDataError.invoice_price.required = true;
        haveFieldError = true;
      }

      // 有开票金额
      if (formData.invoice_price) {

        // 格式不对
        const pricePatternValid = /^\d+(\.\d{1,2})?$/.test(formData.invoice_price);
        if (!pricePatternValid) {
          newFormDataError.invoice_price.pattern = true;
          haveFieldError = true;
        }

        // 开票金额小于0或者大于最大值
        const LessThanZero = +formData.invoice_price < 1;
        const moreThanMax = +formData.invoice_price > (totalOrderPrice / 100).toFixed(2);
        if (pricePatternValid && (LessThanZero || moreThanMax)) {
          newFormDataError.invoice_price.maxOrMin = true;
          haveFieldError = true;
        }
      }
    }

    // 纸质发票
    if (formData.invoice_type === 1) {

      // 收货人
      if (!formData.express.addressee) {
        newFormDataError.express.addressee.required = true;
        haveFieldError = true;
      }

      // 联系电话未填
      if (!formData.express.mobile_phone) {
        newFormDataError.express.mobile_phone.required = true;
        haveFieldError = true;
      }

      // 联系电话格式不对
      const mobilePatternInvalid = !/1\d{10}/.test(formData.express.mobile_phone);
      if (formData.express.mobile_phone && mobilePatternInvalid) {
        newFormDataError.express.mobile_phone.pattern = true;
        haveFieldError = true;
      }

      // 没选省
      if (!formData.express.province_code) {
        newFormDataError.express.province_code.required = true;
        haveFieldError = true;
      }

      // 没选市
      if (formData.express.province_code && !formData.express.city_code) {
        newFormDataError.express.city_code.required = true;
        haveFieldError = true;
      }

      // 可能没有区
      if (formData.express.province_code && formData.express.city_code && pcds[formData.express.city_code]) {

        // 没选区
        if (!formData.express.county_code) {
          newFormDataError.express.county_code.required = true;
          haveFieldError = true;
        }
      }

      // 没填详细地址
      if (!formData.express.detail_address) {
        newFormDataError.express.detail_address.required = true;
        haveFieldError = true;
      }
    }

    // 发票抬头
    if (!formData.invoice_header) {
      newFormDataError.invoice_header.required = true;
      haveFieldError = true;
    }

    // 类型为公司
    if (formData.header_type === 0) {

      // 公司税号没填
      if (!formData.taxer_id_num) {
        newFormDataError.taxer_id_num.required = true;
        haveFieldError = true;
      }

      // 公司税号格式不对
      const taxerIdNumPatternInvalid = !/^[a-zA-Z0-9]+$/.test(formData.taxer_id_num);
      if (formData.taxer_id_num && taxerIdNumPatternInvalid) {
        newFormDataError.taxer_id_num.pattern = true;
        haveFieldError = true;
      }
    }

    // 电子发票
    if (formData.invoice_type === 0) {

      // 输入了就验证格式
      if (formData.email) {
        const emailPatternInvalid = !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email);
        if (emailPatternInvalid) {
          newFormDataError.email.pattern = true;
          haveFieldError = true;
        }
      }
    }

    return { haveFieldError, newFormDataError };
  },

  // 创建参数对象
  createParams(orderInvoiceId, formData, orders, cashFee) {
    const params = Object.assign({}, formData, {
      invoice_price: +(+formData.invoice_price * 100).toFixed(0),
      order_id_set: orderInvoiceId ? undefined : orders.map(order => order.id),
      order_invoice_id: orderInvoiceId,
      cash_fee: typeof cashFee !== 'undefined' ? cashFee : undefined,
    });

    // 更新不传价格
    if (orderInvoiceId) {
      delete params.invoice_price;
    }

    // 电子发票
    if (formData.invoice_type === 0) {
      delete params.express;

      // 没填邮箱就不传
      if (!params.email) {
        delete params.email;
      }
    } else {

      // 纸质发票
      delete params.email;

      // 没有区
      if (!params.express.county_code) {
        params.express.county_code = 0;
      }
    }

    // 个人类型
    if (formData.header_type === 1) {
      delete params.taxer_id_num;
    }

    return params;
  },
};



// WEBPACK FOOTER //
// ./src/services/invoice-service.js